import apiClient from './apiClient';

export interface SearchResults {
  projects: { ProjectKey: string; ProjectId: string; ProjectName: string }[];
  samples: { SampleKey: string; SampleId: string; LocationKey: string; LocationId: string; LocationName: string; ProjectId: string }[];
  locations: { LocationKey: string; LocationId: string; LocationName: string; ProjectId: string }[];
  workOrders: { WorkOrderKey: string; WorkOrderId: string; WorkOrderStatus: string; ProjectId: string }[];
}

export async function searchAll(query: string): Promise<SearchResults> {
  const response = await apiClient.get<SearchResults>('/search', { params: { q: query } });
  return response.data;
}
